import React from 'react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { Alert, Box, Button, Icon, Link, Set } from 'bumbag';
import { Field, Form, Formik } from 'formik';
import _get from 'lodash/get';
import Loads from 'react-loads';

import ErrorMessage from '@medipass/react-core/components/ErrorMessage';
import { Select } from '@medipass/react-core/components/Select/Select.component';
import WithLoadingIndicator from '@medipass/react-core/WithLoadingIndicator';
import sdk from '@medipass/web-sdk';

import HealthFundCardFields from './HealthFundCardFields';

import SubmitCancelButtons from '../../SubmitCancelButtons';

type Props = {
  isHealthFundUpdatesDisabled: boolean;
  funder?: Record<string, any>;
  initialValues?: Record<string, any> | null | undefined;
  isHealthFundRequired?: boolean;
  isMobileTitle?: boolean;
  isSelfCheckoutSession?: boolean;
  isSubmitButtonInsideSection?: boolean;
  onClickCancel?: ((...args: Array<any>) => any) | null | undefined;
  onSubmit: (...args: Array<any>) => any;
  showFieldsIfUnsupported?: boolean;
  showName?: boolean;
  showDOB?: boolean;
  submitButtonRenderer?: ((...args: Array<any>) => any) | null | undefined;
  title: string;
  returnToCartUrl: string | undefined;
  unsupportedMessage?: string;
  runVerifyMember?: boolean;
};
const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  dob: '',
  healthFund: '',
  healthFundId: '',
  cardIssueNumber: '',
  cardNumber: '',
  cardRank: '',
  issueDate: '',
  membershipNumber: '',
};
export default class HealthFundAccountForm extends React.Component<Props> {
  static defaultProps = {
    isHealthFundUpdatesDisabled: false,
    funder: undefined,
    isHealthFundRequired: true,
    isSelfCheckoutSession: false,
    isSubmitButtonInsideSection: false,
    isMobileTitle: true,
    initialValues: INITIAL_VALUES,
    onClickCancel: null,
    showFieldsIfUnsupported: true,
    showName: false,
    showDOB: false,
    submitButtonRenderer: null,
    unsupportedMessage: undefined,
    runVerifyMember: true,
    returnToCartUrl: undefined,
  };
  handleChangeHealthFund =
    // @ts-expect-error TS(7031): Binding element 'setFieldValue' implicitly has an ... Remove this comment to see the full error message


      ({ setFieldValue }) =>
      () => {
        setFieldValue('cardIssueNumber', '');
        setFieldValue('cardNumber', '');
        setFieldValue('cardRank', '');
        setFieldValue('issueDate', '');
        setFieldValue('membershipNumber', '');
      };
  handleRemoveHealthFund =
    // @ts-expect-error TS(7031): Binding element 'setFieldValue' implicitly has an ... Remove this comment to see the full error message


      ({ setFieldValue }) =>
      () => {
        setFieldValue('healthFund', '');
        setFieldValue('healthFundId', '');
        setFieldValue('cardIssueNumber', '');
        setFieldValue('cardNumber', '');
        setFieldValue('cardRank', '');
        setFieldValue('issueDate', '');
        setFieldValue('membershipNumber', '');
      };
  render = () => {
    const {
      isHealthFundUpdatesDisabled,
      funder,
      initialValues,
      isHealthFundRequired,
      isMobileTitle,
      isSelfCheckoutSession,
      isSubmitButtonInsideSection,
      onClickCancel,
      onSubmit,
      showFieldsIfUnsupported,
      showName,
      showDOB,
      submitButtonRenderer,
      title,
      unsupportedMessage,
      returnToCartUrl,
      runVerifyMember,
    } = this.props;
    return (
      <Loads load={onSubmit}>
        {/* @ts-expect-error TS(7031): Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message */}
        {({ error, load: handleSubmitMemberDetails, isLoading, isError }) => (
          <Box>
            <Formik initialValues={{ ...INITIAL_VALUES, ...initialValues }} onSubmit={handleSubmitMemberDetails}>
              {({ resetForm, setFieldValue, values }) => {
                const hasNoFund = !isHealthFundRequired && !values.healthFundId;
                return (
                  <Form noValidate>
                    <Set display="block" orientation="vertical" spacing="major-2">
                      {isMobileTitle ? <p className="font-semibold">{title}</p> : <h2>{title}</h2>}
                      <Loads
                        loadOnMount
                        load={() =>
                          sdk.healthfunds.getHealthFunds(
                            { funderId: _get(funder, '_id') },
                            isSelfCheckoutSession ? { tokenType: 'session' } : {},
                          )
                        }
                      >
                        {/* @ts-expect-error TS(7031): Binding element 'response' implicitly has an 'any'... Remove this comment to see the full error message */}
                        {({ response, isLoading, isSuccess }) => {
                          const options = response
                            ? // @ts-expect-error TS(7006): Parameter 'healthFund' implicitly has an 'any' typ... Remove this comment to see the full error message
                              response.map(healthFund => ({
                                label: healthFund.displayName,
                                value: healthFund._id,
                              }))
                            : [];
                          return (
                            <WithLoadingIndicator isActive={isLoading}>
                              {isSuccess && response && (
                                <>
                                  <Field
                                    component={Select.Formik}
                                    name="healthFundId"
                                    label="Health fund"
                                    disabled={isHealthFundUpdatesDisabled}
                                    onChange={this.handleChangeHealthFund({
                                      setFieldValue,
                                    })}
                                    options={options}
                                    placeholder="Select your health fund..."
                                  />
                                  {isHealthFundUpdatesDisabled && returnToCartUrl && (
                                    <Link href={returnToCartUrl}>Update health fund</Link>
                                  )}
                                </>
                              )}
                            </WithLoadingIndicator>
                          );
                        }}
                      </Loads>
                      <HealthFundCardFields
                        cardholder={showName ? `${values.firstName} ${values.lastName}` : null}
                        cardIssueNumber={values.cardIssueNumber}
                        cardNumber={values.cardNumber}
                        healthFundId={_get(values, 'healthFundId')}
                        issueDate={values.issueDate}
                        isSelfCheckoutSession={isSelfCheckoutSession}
                        membershipNumber={values.membershipNumber}
                        cardRank={values.cardRank}
                        showFieldsIfUnsupported={showFieldsIfUnsupported}
                        showName={showName}
                        showDOB={showDOB}
                        unsupportedMessage={unsupportedMessage}
                        showVerifyFields={runVerifyMember}
                      />
                      {!isHealthFundRequired && values.healthFundId && (
                        <Box display="flex" justifyContent="flex-end">
                          <Button
                            palette="secondary"
                            variant="ghost"
                            size="small"
                            onClick={this.handleRemoveHealthFund({
                              setFieldValue,
                            })}
                          >
                            {/* @ts-expect-error TS(2322): Type 'IconDefinition' is not assignable to type 's... Remove this comment to see the full error message */}
                            <Icon icon={faTimes} type="font-awesome" marginRight="major-1" /> Remove fund
                          </Button>
                        </Box>
                      )}
                      {isError && (
                        <Alert variant="tint" hasIcon marginTop="major-2" type="danger">
                          <ErrorMessage description="Unable to submit health fund" err={error} />
                        </Alert>
                      )}
                      {isSubmitButtonInsideSection && (
                        <Box marginTop="major-3">
                          {submitButtonRenderer ? (
                            submitButtonRenderer({
                              hasNoFund,
                              isDisabled: !values.healthFundId,
                              isLoading,
                            })
                          ) : (
                            <SubmitCancelButtons
                              cancelText="CANCEL"
                              submitProps={{
                                disabled: isHealthFundRequired && !values.healthFundId,
                              }}
                              isLoading={isLoading}
                              onClickCancel={onClickCancel}
                              submitText="SAVE"
                            />
                          )}
                        </Box>
                      )}
                      {!isSubmitButtonInsideSection && (
                        <Box>
                          {submitButtonRenderer ? (
                            submitButtonRenderer({
                              hasNoFund,
                              isDisabled: !values.healthFundId,
                              isLoading,
                            })
                          ) : (
                            <SubmitCancelButtons
                              cancelText="CANCEL"
                              submitProps={{
                                disabled: isHealthFundRequired && !values.healthFundId,
                              }}
                              isLoading={isLoading}
                              onClickCancel={onClickCancel}
                              submitText="SAVE"
                            />
                          )}
                        </Box>
                      )}
                    </Set>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        )}
      </Loads>
    );
  };
}
